import { useDelete } from '../../HttpClient';
import { useMutationWithErrorHandling } from '../../../hooks/UseMutationWithErrorHandling';

export function useRemoveAccountFlag() {
  const deleteAPI = useDelete(true, "ams");
  const removeAccountFlag = (accountId: string, key: string) => {
    return deleteAPI(`/api/proxy/ams/account-service/account/${accountId}/flags/${key}`);
  };

  return useMutationWithErrorHandling({
    mutationFn: ({ accountId, key }: { accountId: string, key: string}) =>
      removeAccountFlag(accountId, key),
  });
}
